module.exports = __webpack_public_path__ + "media/images/login-b113ed339fc382b0b14a8673de7fd7bd.svg";